import React from 'react';

import NavBar, { View } from '../../../components/NavBar';

import formStyles from '../../FormStart/index.module.css';
import questionStyles from '../../../components/Question/index.module.css';

interface Props {
  message: string;
}
const Message: React.FC<Props> = ({ message }) => {
  return (
    <>
      <NavBar view={View.Login} />
      <div className={formStyles.FormContainer}>
        <div className={formStyles.Form}>
          <div>
            <label htmlFor={`receipt-label`} className={questionStyles.Label}>
              {message}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
